import {defaults} from 'lodash'
import {CSSProperties} from 'react'

export interface SvgProps {
  width?: number
  height?: number
  fill?: string
  stroke?: string
  style?: CSSProperties
}

export const defaultSvgProps = <T extends SvgProps>(props: T | undefined, defaultProps: Partial<T>) => {
  return defaults({...props}, defaultProps) as T
}
